import Swiper, { FreeMode, Navigation, Pagination, Scrollbar } from 'swiper'

const initHIWSwiper = () => {
  new Swiper('.hiw.swiper', {
    modules: [Scrollbar, Pagination, Navigation, FreeMode],
    slidesPerView: '1',
    spaceBetween: 24,

    pagination: {
      el: '.hiw__swiper-pagination',
    },

    navigation: {
      nextEl: '.hiw__swiper-nav.next',
      prevEl: '.hiw__swiper-nav.prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: undefined,
        enabled: false,
      },
    },
  })
}

export default initHIWSwiper
